var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUk(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5 23C17.8513 23 23 17.8513 23 11.5C23 5.14873 17.8513 0 11.5 0C5.14873 0 0 5.14873 0 11.5C0 17.8513 5.14873 23 11.5 23Z",
    fill: "#F0F0F0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.37722 4.49902C1.47388 5.67431 0.792733 7.02893 0.396118 8.50053H6.37872L2.37722 4.49902Z",
    fill: "#0052B4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.6037 8.5C22.2071 7.02845 21.5259 5.67383 20.6226 4.49854L16.6212 8.5H22.6037Z",
    fill: "#0052B4"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0.396118 14.5005C0.792778 15.972 1.47393 17.3267 2.37722 18.5019L6.37859 14.5005H0.396118Z",
    fill: "#0052B4"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5012 2.37763C17.3259 1.47429 15.9714 0.793144 14.4998 0.396484V6.37904L18.5012 2.37763Z",
    fill: "#0052B4"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M4.49854 20.623C5.67383 21.5263 7.02845 22.2074 8.5 22.6041V16.6216L4.49854 20.623Z",
    fill: "#0052B4"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M8.49995 0.396484C7.0284 0.793145 5.67378 1.47429 4.49854 2.37758L8.49995 6.379V0.396484Z",
    fill: "#0052B4"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4999 22.6041C15.9714 22.2074 17.326 21.5263 18.5013 20.623L14.4999 16.6216V22.6041Z",
    fill: "#0052B4"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6212 14.5005L20.6226 18.5019C21.5259 17.3267 22.2071 15.972 22.6037 14.5005H16.6212Z",
    fill: "#0052B4"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M22.9027 10H13.0001H13V0.0973457C12.509 0.0334219 12.0084 0 11.5 0C10.9915 0 10.491 0.0334219 10 0.0973457V9.99992V9.99997H0.0973457C0.0334219 10.491 0 10.9916 0 11.5C0 12.0085 0.0334219 12.509 0.0973457 13H9.99992H9.99997V22.9027C10.491 22.9666 10.9915 23 11.5 23C12.0084 23 12.509 22.9666 13 22.9027V13.0001V13H22.9027C22.9666 12.509 23 12.0085 23 11.5C23 10.9916 22.9666 10.491 22.9027 10Z",
    fill: "#D80027"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5 14.5L19.6317 19.6317C19.8677 19.3958 20.0929 19.1491 20.3077 18.8934L15.9142 14.5H14.5V14.5Z",
    fill: "#D80027"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M8.50002 14.5H8.49993L3.36829 19.6317C3.60422 19.8677 3.85088 20.0928 4.10658 20.3076L8.50002 15.9141V14.5Z",
    fill: "#D80027"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M8.49994 8.5V8.49991L3.36825 3.36816C3.13223 3.60409 2.90708 3.85076 2.69226 4.10646L7.08575 8.49996H8.49994V8.5Z",
    fill: "#D80027"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5 8.50011L19.6317 3.36832C19.3958 3.1323 19.1491 2.90715 18.8934 2.69238L14.5 7.08588V8.50011Z",
    fill: "#D80027"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUk);
export default __webpack_public_path__ + "static/media/uk.8016476dae17d1dab3bb4293a1c90b63.svg";
export { ForwardRef as ReactComponent };